import PropTypes from 'prop-types';


const WhatsAppFloat = ({ phoneNumber = '1234567890' }) => {
  return (
    <a
      target="_blank"
      href={`https://wa.me/${phoneNumber}`}
      className="fixed bottom-6 right-6 z-50 cursor-pointer"
      rel="noreferrer"
    >
      <img
        src="/images/whatsapp-icon2.svg"
        alt="whatsapp"
        width={0}
        height={0}
        className="w-auto h-auto"
      />
    </a>
  );
};
WhatsAppFloat.propTypes = {
  phoneNumber: PropTypes.string,
};

export default WhatsAppFloat;
